import { baseApiAxios } from './js/portal/api';
import {
  addApiKeyPermissionsMapping,
  initAdminApiKeysTable,
  loadAllApiKeys,
  updateApiKeyInformation,
} from './js/portal/apikeys';
import { Datatable } from './Datatable';

const tableId = 'apiKeysTable';

export default function AdminListApiKeysPage() {
  const page = (
    <>
      <div class="row">
        <div class="col-lg-12">
          <div id="form-error" class="alert alert-danger" style="display: none">
            <ul />
          </div>
          <div id="form-success" class="alert alert-success" style="display: none">
            <ul />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="card infobox">
            <div class="card-body">
              <h4>
                API Settings: <span id="chosenApi">portal</span>
              </h4>
              <ul>
                <li>
                  <strong>AWS Account Id:</strong> <span id="apiAccountId" />
                </li>
                <li>
                  <strong>AWS Region:</strong> <span id="apiRegion" />
                </li>
                <li>
                  <strong>Usage Plan Id:</strong> <span id="apiUsagePlanId" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="row" id="edit-api-key-permissions-form" style="display: none" />

      <Datatable tableId={tableId} />
    </>
  );

  function onPageReady() {
    initAdminApiKeysTable(tableId);
    loadAllApiKeys('portal');
    baseApiAxios.getSettings({ action: 'get-settings', settings: ['api_keys'] }).then(result => {
      updateApiKeyInformation('portal', JSON.stringify(result.api_keys['portal']));
    });
    baseApiAxios
      .postApiKeyData({ action: 'list-api-resources-methods', target: 'portal' })
      .then(addApiKeyPermissionsMapping);
  }

  return [page, onPageReady];
}
